import { render, staticRenderFns } from "./sin-field.vue?vue&type=template&id=285d7f9b&scoped=true"
import script from "./sin-field.vue?vue&type=script&lang=ts"
export * from "./sin-field.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "285d7f9b",
  null
  
)

export default component.exports